(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["framelab-footer"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('framelab-welcome');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'framelabWelcome15';
  const tags = dialog.querySelector('[data-welcome-tags]');
  dialog.querySelectorAll('input[name="welcome_interest"]').forEach((input) => {
    input.addEventListener('change', () => {
      if (input.checked && tags) tags.value = 'newsletter,framelab_welcome_15,interest_' + input.value;
    });
  });
  const success = dialog.querySelector('[data-welcome-success]');
  const error = dialog.querySelector('.fl-welcome-error');
  let joined = false;
  try { joined = localStorage.getItem(key) === 'subscribed'; } catch (_) {}
  const dismiss = () => {
    try { if (!success) localStorage.setItem(key, String(Date.now())); } catch (_) {}
    dialog.close();
  };
  dialog.querySelector('.fl-welcome-close').addEventListener('click', dismiss);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  const open = () => {
    if (document.querySelector('dialog[open]')) return;
    dialog.showModal();
    if (success) dialog.querySelector('.fl-welcome-success')?.focus({preventScroll:true});
  };
  if (success) {
    try { localStorage.setItem(key, 'subscribed'); } catch (_) {}
    open();
    return;
  }
  if (error) { open(); return; }
  if (joined || location.pathname.startsWith('/cart') || location.pathname.startsWith('/account') || location.pathname.startsWith('/checkouts')) return;
  try {
    const dismissed = Number(localStorage.getItem(key));
    if (dismissed && Date.now() - dismissed < 7 * 24 * 60 * 60 * 1000) return;
  } catch (_) {}
  window.setTimeout(open, 5000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["framelab-product"]) return;
  try {
    
(()=>{const gallery=document.querySelector('[data-video-gallery]');if(!gallery)return;const video=gallery.querySelector('#fl-product-video'),panel=gallery.querySelector('.main-product-photo'),caption=gallery.querySelector('[data-video-caption]'),button=gallery.querySelector('[data-gallery-video]');if(!video)return;let visible=true;const play=()=>{if(panel.dataset.videoSelected==='true'&&visible&&!document.hidden){video.play().catch(()=>{});}};const show=active=>{panel.dataset.videoSelected=String(active);caption.hidden=!active;button.setAttribute('aria-pressed',String(active));if(active)play();else video.pause();};gallery.querySelectorAll('[data-gallery-image]').forEach(b=>b.addEventListener('click',()=>show(false)));button.addEventListener('click',()=>show(true));document.querySelectorAll('[data-option-value]').forEach(b=>b.addEventListener('click',()=>show(false)));if('IntersectionObserver'in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)play();else video.pause();},{threshold:.2}).observe(panel);document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else play();});video.addEventListener('loadeddata',play,{once:true});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
